import { useLazyQuery, useMutation } from "@apollo/client";
import { clientNeoFact } from "@neonumy/api-clients";
import { useEffect } from "react";
import { onErrorGraphql } from "utils/onErrorGraphql";
import {
  GET_COMMENT,
  LIST_COMMENTS,
  UPDATE_COMMENT,
  CREATE_COMMENT,
  DELETE_COMMENT,
} from "queries/neoFact/catalog";
import { FormInstance } from "antd";

export default function useCommentsApi(id?: ID, form?: FormInstance<any>) {
  const [listComments, { refetch, loading, data: listCommentsData, error: listCommentsError }] =
    useLazyQuery<ListCommentsResponse, ListCommentsVars>(LIST_COMMENTS, {
      client: clientNeoFact,
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    if (listCommentsError) onErrorGraphql(listCommentsError);
  }, [listCommentsError]);

  const dataSource =
    listCommentsData?.listComments?.results?.map(item => ({
      ...item,
      key: item.id,
    })) ?? [];

  const totalCount = listCommentsData?.listComments?.totalCount ?? 0;

  const [getComment, { refetch: refetchGetComment, data: getCommentData, error: getCommentError }] =
    useLazyQuery<GetCommentResponseResponse, GetVarTypeID>(GET_COMMENT, {
      client: clientNeoFact,
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    if (getCommentError) onErrorGraphql(getCommentError);
  }, [getCommentError]);

  const formData = getCommentData?.getComment;

  useEffect(() => {
    if (!formData) return;

    form?.setFields([
      {
        name: "name",
        value: formData?.name,
      },
      {
        name: "reference",
        value: formData?.reference,
      },
      {
        name: "description",
        value: formData?.description,
      },
    ]);
  }, [formData, form]);

  const [
    createUpdateComment,
    { loading: createUpdateCommentLoading, error: createUpdateCommentError },
  ] = useMutation<CreateUpdateCommentMutationResponse, CreateUpdateCommentVars>(
    id ? UPDATE_COMMENT : CREATE_COMMENT,
    {
      client: clientNeoFact,
      fetchPolicy: "no-cache",
    },
  );

  useEffect(() => {
    if (createUpdateCommentError) onErrorGraphql(createUpdateCommentError);
  }, [createUpdateCommentError]);

  const [deleteComment, { loading: deleteCommentLoading, error: deleteCommentError }] = useMutation<
    DeleteCommentResponse,
    GetVarTypeID
  >(DELETE_COMMENT, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (deleteCommentError) onErrorGraphql(deleteCommentError);
  }, [deleteCommentError]);

  return {
    refetch,
    loading,
    formData,
    dataSource,
    totalCount,
    getComment,
    listComments,
    deleteComment,
    refetchGetComment,
    createUpdateComment,
    deleteCommentLoading,
    createUpdateCommentLoading,
  };
}
